module.exports = __webpack_public_path__ + "teqbahn-assets/media/Zarina.headshot.a19e2c20.JPG";